import React from 'react'
import Banner from '../components/solutions/Banner'
import Services from '../components/solutions/Services'

export  function Solutions() {

  return (
      <>
        <Banner />
        <Services />
      </>
      
    )
}

export default Solutions